import InstagramSearchPage from "./InstagramSearchPage"
export default InstagramSearchPage
